export default class TypeaheadLocationType {

  // TODO: review the rest of the search types in the typehead.
  /**
  * This is a static method that returns a new instance of the LocationType class with the type
  * 'city'.
  * @returns A new instance of the `LocationType` class with the value of `'city'` as its parameter.
  */
  static get City() {
    return new TypeaheadLocationType('city');
  }

  /**
  * The above code defines a static getter function that returns a new instance of a LocationType object
  * with the type 'market'.
  * @returns A new instance of the `LocationType` class with the type `market` is being returned.
  */
  static get Market() {
    return new TypeaheadLocationType('market');
  }

  /**
   * This is a static method that returns a new instance of the LocationType class with the type
   * 'community'.
   * @returns A new instance of the `LocationType` class with the value of `'community'` as its parameter.
   */
  static get Community() {
    return new TypeaheadLocationType('community');
  }

  /**
  * This is a static method that returns a new instance of the LocationType class with the type
  * 'masterPlannedCommunity'.
  * @returns A new instance of the `LocationType` class with the value of `'masterPlannedCommunity'` as its parameter.
  */
  static get MasterPlannedCommunity() {
    return new TypeaheadLocationType('masterPlannedCommunity');
  }

  /**
  * The function returns a new LocationType object with the type 'zip'.
  * @returns A new instance of the `LocationType` class with the argument `'zip'`.
  */
  static get Zip() {
    return new TypeaheadLocationType('zip');
  }

  /**
  * The function returns a new instance of a LocationType object with the type 'county'.
  * @returns A new instance of the LocationType class with the type 'county'.
  */
  static get County() {
    return new TypeaheadLocationType('county');
  }

  constructor(name) {
    this.name = name;
  }

  /**
  * This is a toString() method in JavaScript that returns the name property of an object as a string.
  * @returns The `toString()` method is returning the value of the `name` property of the object.
  */
  toString() {
    return `${this.name}`;
  }
}